import { render, staticRenderFns } from "./PublisherChatAvatar.vue?vue&type=template&id=f39dcfd4&scoped=true"
import script from "./PublisherChatAvatar.vue?vue&type=script&lang=js"
export * from "./PublisherChatAvatar.vue?vue&type=script&lang=js"
import style0 from "./PublisherChatAvatar.vue?vue&type=style&index=0&id=f39dcfd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39dcfd4",
  null
  
)

export default component.exports